import produce from 'immer';

import {
  GET_REFRESH_TOKEN_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  SUPER_ADMIN_AGENCY_LOGIN,
} from '@actions/auth';

import {
  hasComcateAdminAccess,
  hasCreateCasePageAccess,
  hasInternalSubmissionAccess,
  hasProductAdminAccess,
  hasProductCEAccess,
  hasProductCRMAccess,
  hasReportAccess,
  hasSiteAdminAccess,
  hasUserAdminAccess,
  isSuperAdmin,
  storeUserProfile,
} from '@utils/AuthUtil';

const initialState: IAuthStore = {
  isLoggingIn: false,
  isAuthenticated: false,
  isComcateAdmin: false,
  isSuperAdmin: false,
  hasSiteAdminAccess: false,
  hasUserAdminAccess: false,
  hasProductCEAdminAccess: false,
  hasProductCRMAdminAccess: false,
  hasProductCEAccess: false,
  hasProductCRMAccess: false,
  hasCreateCasePageAccess: false,
  hasInternalSubmisssionAccess: false,
  hasReportAccess: false,
  userProfile: null,
  error: null,
  serverError: null,
};

export default (state: IAuthStore = initialState, action: any) =>
  produce(state, (draftState: IAuthStore) => {
    switch (action.type) {
      case LOGIN_REQUEST:
        draftState.isLoggingIn = true;
        draftState.isAuthenticated = false;
        draftState.isComcateAdmin = false;
        draftState.isSuperAdmin = false;
        draftState.hasSiteAdminAccess = false;
        draftState.hasUserAdminAccess = false;
        draftState.hasProductCEAdminAccess = false;
        draftState.hasProductCRMAccess = false;
        draftState.hasProductCEAccess = false;
        draftState.hasCreateCasePageAccess = false;
        draftState.hasReportAccess = false;
        draftState.userProfile = null;
        draftState.hasInternalSubmisssionAccess = false;
        draftState.error = null;
        draftState.serverError = null;

        return;

      case LOGIN_SUCCESS:
        const userProfile: IUserProfile = action.userProfile;

        draftState.isLoggingIn = false;
        draftState.isAuthenticated = true;
        draftState.isComcateAdmin = hasComcateAdminAccess(userProfile);
        draftState.isSuperAdmin = isSuperAdmin(userProfile);
        draftState.hasSiteAdminAccess = hasSiteAdminAccess(userProfile);
        draftState.hasUserAdminAccess = hasUserAdminAccess(userProfile);
        draftState.hasProductCEAdminAccess = hasProductAdminAccess(ConfigProductType.XERCE, userProfile);
        draftState.hasProductCRMAdminAccess = hasProductAdminAccess(ConfigProductType.CRM, userProfile);
        draftState.hasProductCEAccess = hasProductCEAccess(userProfile);
        draftState.hasProductCRMAccess = hasProductCRMAccess(userProfile);
        draftState.hasCreateCasePageAccess = hasCreateCasePageAccess(userProfile);
        draftState.hasReportAccess = hasReportAccess(userProfile);
        draftState.userProfile = userProfile;
        // tslint:disable-next-line: max-line-length
        draftState.hasInternalSubmisssionAccess = hasInternalSubmissionAccess(userProfile);
        draftState.error = null;

        return;

      case SUPER_ADMIN_AGENCY_LOGIN:
        const token = action.payload;
        const superAdminProfile: IUserProfile = storeUserProfile(token);

        draftState.isLoggingIn = false;
        draftState.isAuthenticated = true;
        draftState.isComcateAdmin = false;
        draftState.isSuperAdmin = true;
        draftState.hasSiteAdminAccess = true;
        draftState.hasUserAdminAccess = true;
        draftState.hasProductCEAdminAccess = true;
        draftState.hasCreateCasePageAccess = hasCreateCasePageAccess(superAdminProfile);
        draftState.hasReportAccess = true;
        draftState.hasInternalSubmisssionAccess = hasInternalSubmissionAccess(superAdminProfile);
        draftState.userProfile = superAdminProfile;
        draftState.error = null;
        draftState.serverError = null;

        return;

      case LOGIN_FAILURE:
        draftState.isLoggingIn = false;
        draftState.isAuthenticated = false;
        draftState.isComcateAdmin = false;
        draftState.isSuperAdmin = false;
        draftState.hasSiteAdminAccess = false;
        draftState.hasUserAdminAccess = false;
        draftState.hasProductCEAdminAccess = false;
        draftState.hasProductCEAccess = false;
        draftState.hasProductCRMAccess = false;
        draftState.hasCreateCasePageAccess = false;
        draftState.hasReportAccess = false;
        draftState.userProfile = null;
        draftState.hasInternalSubmisssionAccess = false;
        draftState.error = action.error;
        draftState.serverError = action.serverError;

        return;

      case GET_REFRESH_TOKEN_SUCCESS:
        draftState.userProfile = storeUserProfile(action.response.token);

        return;

      case LOGOUT_SUCCESS:
        return;
    }
  });
